import { Component, computed, inject } from '@angular/core';
import { CategoryService } from '../../services/category.service';
import { AdminDiscountService } from './admin-discounts.service';
import { rxResource } from '@angular/core/rxjs-interop';
import { combineLatest, map } from 'rxjs';
import { RequirementsService } from '../../../services/requirements.service';
import { FormBuilder, Validators } from '@angular/forms';
import { Category } from '../../../models/category.model';
import { Requirement } from '../../../models/requirement.model';

@Component({
  selector: 'app-admin-discounts',
  standalone: false,
  templateUrl: './admin-discounts.component.html',
  styleUrl: './admin-discounts.component.scss'
})
export class AdminDiscountsComponent {

  public readonly categoryService = inject(CategoryService);

  public readonly discountService = inject(AdminDiscountService);

  public readonly fb = inject(FormBuilder);

  public readonly requirementService = inject(RequirementsService);

  title = 'Descuentos';

  subtitle = 'Administra los descuentos sobre categorias de productos';

  form = this.fb.group({
    name: this.fb.control<string>('', { nonNullable: true, validators: [Validators.required] }),
    active: this.fb.control<boolean>(true, { nonNullable: true }),
    requirement_ids: this.fb.control<number[]>([], { nonNullable: true, validators: [Validators.required] }),
    category_ids: this.fb.control<number[]>([], { nonNullable: true, validators: [Validators.required] }),
    discount_percent: this.fb.control<number>(0, { nonNullable: true, validators: [Validators.required, Validators.min(0), Validators.max(100)] }),
  });


  resource = rxResource({
    stream: () => {
      return combineLatest({
        categories: this.categoryService.all().pipe(map((res) =>res.body || [])),
        requirements: this.requirementService.all().pipe(map((res) =>res.body || [])),
      }
      );
    },
  });

  categories = computed(() => this.resource.value().categories || []);
  requirements = computed(() => this.resource.value().requirements || []);


}
